function hasExternalLinks(msg: string): boolean {
    return msg.includes("(http");
}

function extractImages(msg: string): string[] {
    // Extract any image strings present
    const regex = /[^ \s(]+\.(?:jpg|jpeg|png|gif|bmp|tiff|webm|svg)/g;
    return msg.match(regex) || [];
}

function extractMdImages(msg: string): string[] {
    // Extract any image strings present which are formatted with markdown
    const regex = /!\[[^\][]*\]\(([^ \s(]+\.(?:jpg|jpeg|png|gif|bmp|tiff|webm|svg))\)'/g;
    const matches: string[] = [];
    let match: RegExpExecArray | null;
    while ((match = regex.exec(msg)) !== null) {
        matches.push(match[1]);
    }
    return matches;
}

function removeMdImagesDesc(msg: string): string {
    // Drop images description to save tokens
    return msg.replace(/!\[[^\]\[]*\]\(([^ \s\(]+\.(?:jpg|jpeg|png|gif|bmp|tiff|webm|svg))\)/g, (x, p1) => {
        return `![](${p1})`;
    });
}

function allImagesFormattedWithMd(msg: string): boolean {
    const images = new Set(extractImages(msg));
    const mdImages = new Set(extractMdImages(msg));
    return images.size === mdImages.size && [...images].every(img => mdImages.has(img));
}

function allImagesComeFromLessonPlan(msg: string, lessonPlan: string): boolean {
    const lpImages = new Set(extractMdImages(lessonPlan));
    const msgImages = new Set(extractImages(msg));
    return [...msgImages].every(img => lpImages.has(img));
}

export function validateReply(msg: string, lessonPlan: string): boolean {
    // If false, regenerate reply from scratch
    return (
        !hasExternalLinks(msg) &&
        allImagesFormattedWithMd(msg) &&
        allImagesComeFromLessonPlan(msg, lessonPlan)
    );
}

function fixSquareLatex(msg: string): string {
    return msg.replace(/\[/g, "$$").replace(/\]/g, "$$")
}

export function processReply(msg: string): string {
    // Apply some simple edits to reply
    msg = removeMdImagesDesc(msg);
    msg = fixSquareLatex(msg);
    return msg;
}
